import ListCompleteCheckIcon from "../../../../../assets/icons/ListCompleteCheckIcon";

interface ItemProps extends React.HTMLAttributes<HTMLLIElement> {
  active: boolean;
  completed?: boolean;
  index: number;
  children: string;
}

export default function Item({
  active,
  completed,
  index,
  children,
  ...rest
}: ItemProps) {
  return (
    <li
      {...rest}
      className={`h-12 px-3 rounded-lg flex items-center cursor-pointer border bg-[#F9FAFB] ${
        active ? "border-[#FFD3C0]" : "border-[#F9FAFB]"
      }`}
    >
      {completed ? (
        <ListCompleteCheckIcon />
      ) : (
        <span
          className={`w-7 h-7 rounded-full text-base font-semibold border justify-center items-center inline-flex ${
            active
              ? "border-primary bg-primary text-white"
              : "border-display-medium bg-white text-display-medium"
          }`}
        >
          {index + 1}
        </span>
      )}
      <span className={`font-medium ml-3 text-display-body`}>{children}</span>
    </li>
  );
}
